module.exports = __webpack_public_path__ + "static/img/BQ.d5fda717.svg";